const clickOutside = {
    beforeMount(el: any, binding: any) {
        el.clickOutsideEvent = (event: any) => {
            // Check if the click is outside the element
            if (!(el === event.target || el.contains(event.target))) {
                binding.value(event); // Call the bound callback
            }
        };
        document.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted(el: any) {
        document.removeEventListener("click", el.clickOutsideEvent);
    },
};

export default clickOutside;